import FieldSelectField_Popover from "./components/popover/popover"
import FieldPopover from "../../popover/popover"
import FieldConfig from "../../../proto/field-config"
import {Group, GroupedData} from "../../../../data-structures/group"
import FieldsCollection from "../../../collection/base/fields-collection"

import FieldSelectField_InlineValueEmpty from "./components/inline-edit/value-empty"
import FieldSelectField_InlineValueNotEmpty from "./components/inline-edit/value-not-empty"
import FieldSelectField_FormValueEmpty from "./components/form/value-empty"
import FieldSelectField_FormValueNotEmpty from "./components/form/value-not-empty"
import FieldSelectField_PickerValueNotEmpty from "./components/picker/value-not-empty"
import FieldSelectField_PickerValueEmpty from "./components/picker/value-empty"
import FieldProto from "../../../proto/field-proto"
import FieldSelectField_ControlView from "./render/control-view"
import FieldSelectField_ControlViewEmpty from "./components/control-view/value-empty"
import FieldSelectField_ControlViewNotEmpty from "./components/control-view/value-not-empty"

export default class FieldSelectField extends FieldPopover {


    public fieldsStructure  : GroupedData
    public fields           : FieldsCollection

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel              = "Select field";

        this.fields                 = _.get(config, 'fields', new FieldsCollection([]))
        this.fieldsStructure        = _.get(config, 'fieldsStructure', [])

        // if no fields passed collect fields from fieldsStructure
        if (this.fields.isEmpty && !_.isEmpty(this.fieldsStructure)) {
            this.fields             = new FieldsCollection([])
            _.map(this.fieldsStructure, (group: Group) => {
                _.map(group.items, (field: FieldProto) => {
                    this.fields.addField(field)
                })
            })
        }

        this.noValueOption          = _.get(config, 'noValueOption', false)
        this.noValueOptionIcon      = _.get(config, 'noValueOptionIcon', undefined)
        this.noValueOptionLabel     = _.get(config, 'noValueOptionLabel', 'None')

        this.components.PopoverMenu         = FieldSelectField_Popover
        this.components.FormValueEmpty      = FieldSelectField_FormValueEmpty
        this.components.FormValueNotEmpty   = FieldSelectField_FormValueNotEmpty
        this.components.InlineValueEmpty    = FieldSelectField_InlineValueEmpty
        this.components.InlineValueNotEmpty = FieldSelectField_InlineValueNotEmpty
        this.components.ControlViewEmpty    = FieldSelectField_ControlViewEmpty
        this.components.ControlViewNotEmpty = FieldSelectField_ControlViewNotEmpty
        this.components.PickerValueEmpty    = FieldSelectField_PickerValueEmpty
        this.components.PickerValueNotEmpty = FieldSelectField_PickerValueNotEmpty

        this.renderComponents.controlView   = FieldSelectField_ControlView
    }

}